module.exports = "<div class=\"overlay flex flex-column\">\r\n  <div class=\"iconContainer flex flex-grow flex-column\">\r\n    <div class=\"flex flex-grow\"></div>\r\n    <div class=\"flex flex-row\">\r\n      <div class=\"flex flex-grow\"></div>\r\n      <app-loading-spinner></app-loading-spinner>\r\n      <div class=\"flex flex-grow\"></div>\r\n    </div>\r\n    <div class=\"flex flex-grow\"></div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/shared/components/loading-overlay/loading-overlay.component.html
// module id = ../../../../../src/app/shared/components/loading-overlay/loading-overlay.component.html
// module chunks = main